import { useMemo } from "react"

import {
    buildEmployeeMonthWorkSummaryText,
    calculateEmployeeMonthWorkSummary
} from "../../../utils/employeeMonthWorkSummary"

const EmployeeMonthWorkSummary = ({ logsByDay, year, monthIndex, isDarkTheme, loading }) => {
    const text = useMemo(() => {
        const summary = calculateEmployeeMonthWorkSummary(logsByDay, year, monthIndex)
        return buildEmployeeMonthWorkSummaryText(summary)
    }, [logsByDay, year, monthIndex])

    if (loading || logsByDay == null) return null

    const hasDetails = text.detailLines.length > 0

    return (
        <div
            className={`asv-employee-month-work-summary${hasDetails ? " asv-employee-month-work-summary--has-details" : ""}${isDarkTheme ? " asv-employee-month-work-summary--dark" : ""}`}
        >
            <p
                className={`asv-employee-month-work-summary-short asv-employee-month-work-summary-short--${text.status} ${isDarkTheme ? "dark-color" : ""}`}
            >
                {text.shortLine}
            </p>
            {hasDetails ? (
                <div
                    className={`asv-employee-month-work-summary-details${isDarkTheme ? " asv-employee-month-work-summary-details--dark" : ""}`}
                    role="tooltip"
                >
                    {text.detailLines.map((line) => (
                        <p key={line} className="asv-employee-month-work-summary-details-line">
                            {line}
                        </p>
                    ))}
                </div>
            ) : null}
        </div>
    )
}

export default EmployeeMonthWorkSummary
